import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Elana Gabrielle (b_16o7r3v1y0, advertiser 9095933244058406210).
// Real numbers from ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS
// (lifetime totals; 31-month tenure from Mar 2024). NEW_AND_RETURNING. Steady
// spender: ~$200/mo on new customers for two and a half years at 5.0x first-year
// ROAS, with the strongest reorder engine of the three new brands — 26
// conversions returning ~8.9x. Monthly series (complete months Sep 2025 –
// Aug 2026) + partial Sep 2026 live in realBrandData.ts.
//
// The budget is POOLED: ADS_SERVER.ADVERTISERS reports one $400 pool serving both
// campaigns, so `totalBudgetDollars` is that pool rather than a sum, and neither
// campaign holds a budget of its own. CAMPAIGN_PERIODS stops populating
// `prorated_budget_local` after Jun 2025, so the monthly series reads every month
// against this same reported pool. `spendingMode` is real
// (ADVERTISERS.spending_mode).
export const advElanaGabrielle: FaireAdvertiserProfileEntity = {
  token: "adv_elana_gabrielle",
  type: "advertiserProfile",
  archetype: "median-budget-median-results",
  displayName: "Textile Brand",
  brandToken: "b_16o7r3v1y0",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 31,
  budget: {
    totalBudgetDollars: 400,
    sharedBudgetDollars: 400,
    spendingMode: "COMPETITIVE",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 51,
    numReorderConversions: 26,
    numTotalConversions: 77,
    // Ad sales are booked sales (TOTAL_SALES_..._FROM_ADS_ACQUIRED_CUSTOMERS on
    // the new segment, TOTAL_SALES on reorder). The ROAS fields run off
    // first-year value ($21,881 new), so they cannot be reconstructed from these.
    totalAdsSalesDollars: 32045,
    newCustomerAdsSalesDollars: 24438,
    reorderAdsSalesDollars: 7607,
    totalAdsSpendDollars: 5211,
    newCustomerAdsSpendDollars: 4353,
    reorderAdsSpendDollars: 858,
    newCustomerBestEstimateFirstYearRoas: 5.03,
    reorderRoas: 8.86,
    combinedFirstYearRoas: 5.66,
    // MANAGER_METRICS_BRAND_ORDERS: 106 orders on the new-customer campaign
    // (from 51 acquired customers) and 29 on the reorder campaign.
    numNewCustomerAdsOrders: 106,
    numReorderAdsOrders: 29,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  // MANAGER_METRICS_BRANDS (ds 2026-09-16), budget_status_tag "limited_20_30",
  // 12-month LTV $395.80. Both segments are HEADROOM_RECOMMENDATION_TYPE with
  // is_eligible_for_increase_recommendation false and
  // HEADROOM_BASED_RECS_LESS_THAN_BUDGET.
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 290,
      maxRecommendedBudgetDollars: 580,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 130,
      maxRecommendedBudgetDollars: 260,
    },
  },
  campaignTokens: ["camp_eg_new", "camp_eg_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-19T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
